"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.findRoot = void 0;
const findRoot = (flat, idx) => {
    const nodes = flat.nodes;
    while (true) {
        const token = nodes[idx];
        idx = token.parent;
        if (!idx)
            return 0;
        if (nodes[idx].type === 'root')
            return idx;
    }
};
exports.findRoot = findRoot;
